import { ActionButton, ActionButtonType, DialogContent } from "@octopusdeploy/design-system-components";
import { useEffect } from "react";
import Dialog from "~/components/Dialog/Dialog";
interface Props {
    open: boolean;
    onContinueNavigating(): void;
    onCancelNavigation(): void;
}
function ConfirmNavigate({ open, onContinueNavigating, onCancelNavigation }: Props) {
    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") {
                onCancelNavigation();
            }
        };
        document.addEventListener("keydown", handleKeyDown, { capture: true });
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [onCancelNavigation]);
    const actions = [
        <ActionButton key="discard" label="Leave and Discard" type={ActionButtonType.Secondary} onClick={onContinueNavigating}/>,
        <ActionButton key="cancel" label="Continue Editing" type={ActionButtonType.Primary} keyboardFocused={true} onClick={onCancelNavigation}/>,
    ];
    return (<Dialog title="Unsaved Changes" actions={actions} open={open}>
            <DialogContent>If you leave this page, your unsaved changes will be lost. Would you like to continue editing?</DialogContent>
        </Dialog>);
}
export default ConfirmNavigate;
